import Chart from "chart.js";

/**
 * Chart.js 2 plugin that writes a label (e.g. "média 81,2%") just above a horizontal reference line,
 * at the left edge of the plot, so the average reads without the legend.
 * @param text Label to write.
 * @param value Y value of the line.
 * @param color Color of the text, the same as the line.
 */
export const lineLabelPlugin = (text: string, value: number, color: string): Chart.PluginServiceRegistrationOptions => ({
  afterDatasetsDraw: (chart: Chart) => {
    const { ctx, chartArea } = chart as unknown as { ctx: CanvasRenderingContext2D; chartArea: Chart.ChartArea };
    const yScale = (chart as unknown as { scales: Record<string, { getPixelForValue: (v: number) => number }> }).scales["y-axis-0"];

    if (!ctx || !yScale) return;

    ctx.save();
    ctx.font = "600 11px Roboto, Arial, sans-serif";
    ctx.fillStyle = color;
    ctx.textBaseline = "bottom";
    ctx.fillText(text, chartArea.left + 6, yScale.getPixelForValue(value) - 4);
    ctx.restore();
  }
});

export default lineLabelPlugin;
